import { clearAuth } from '../store/slices/authSlice';
import { toast } from 'sonner';

// Error handling middleware for RTK Query
export const errorMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  // Handle RTK Query rejected actions
  if (action.type && action.type.includes('rejected')) {
    const error = action.payload?.data || action.error;
    const status = action.payload?.status;

    // Auto-logout on 401 Unauthorized
    if (status === 401) {
      store.dispatch(clearAuth());
      toast.error('Session expired. Please login again.');
      // Redirect to login page is handled by route guards in App.js
    } else if (error) {
      // Show error toast for other errors
      const message =
        error.message ||
        (typeof error === 'string' ? error : 'An error occurred. Please try again.');
      toast.error(message);
    }
  }

  return result;
};

export default errorMiddleware;
